import { buildSavedViewFiltersJson, parseSavedViewFilters } from '../../shared/saved-views/saved-view-filters';

const JIRA_KEY_PATTERN = /[A-Z][A-Z0-9_]*-\d+/;

export function extractJiraKey(value: string | null): string | null {
  if (!value) return null;
  const match = value.match(JIRA_KEY_PATTERN);
  return match ? match[0] : value;
}

/**
 * Filter-Shape der Testfall-Uebersicht, serialisiert in {@code SavedView.filtersJson}
 * (NEX-788). Die Filter sind seit NEX-1057 einwertig; das Array-Format bleibt,
 * damit vor der Umstellung gespeicherte Ansichten weiter gelesen werden koennen
 * (Kappung auf den ersten Wert passiert im Consumer, siehe onSavedViewSelected).
 *
 * <p>Das Feld {@code source} wurde mit NEX-1057 aus dem UI entfernt. Es wird
 * beim Lesen ignoriert (Legacy-Ansichten laufen ohne Fehler durch), aber nicht
 * mehr aktiv gefiltert oder geschrieben.
 */
export interface TestCaseSavedViewFilters {
  query: string | null;
  status: string[];
  execution: string[];
  priority: string[];
  author: string[];
}

const EMPTY_TEST_CASE_SAVED_VIEW_FILTERS: TestCaseSavedViewFilters = {
  query: null,
  status: [],
  execution: [],
  priority: [],
  author: [],
};

export function parseTestCaseSavedViewFilters(filtersJson: string | null): TestCaseSavedViewFilters {
  return parseSavedViewFilters(filtersJson, EMPTY_TEST_CASE_SAVED_VIEW_FILTERS);
}

export function buildTestCaseSavedViewFiltersJson(filters: TestCaseSavedViewFilters): string {
  return buildSavedViewFiltersJson(filters);
}
